import { useMemo } from 'react'

import { useLocation, useParams } from 'react-router'

import { GenericGeoLandingParams } from 'components/page/Landing/Landing.functions'

import { seriousRelationshipParams } from './Special/Special.constants'
import { isSeriousRelaionship } from './Special/Special.functions'

/**
 * Хук useParams возвращает всегда новый объект, что приводит
 * к зацикливанию.
 */
export const useLandingParams = () => {
  const { pathname } = useLocation()
  const { countryId, country, region, regionId, city, cityId, gender } =
    useParams<GenericGeoLandingParams>()

  return useMemo<GenericGeoLandingParams>(() => {
    if (isSeriousRelaionship(pathname)) {
      return { ...seriousRelationshipParams, gender }
    }

    return {
      countryId,
      country,
      region,
      regionId,
      city,
      cityId,
      gender,
    }
  }, [pathname, countryId, country, region, regionId, city, cityId, gender])
}
